/**
 * 業務種別とルートマッピングに関する定数
 */
// 業務種別
export const BUSINESS_TYPE = {
    INDIVIDUAL_EQUIPMENT: "設備案件",
    REPLACEMENT: "入替案件"
};
// 業務種別とルートのマッピング
export const BUSINESS_TYPE_ROUTES = {
    [BUSINESS_TYPE.INDIVIDUAL_EQUIPMENT]: "/individual-equipment",
    [BUSINESS_TYPE.REPLACEMENT]: "/replacement"
};
// デフォルトルート（業務種別が不明な場合）
export const DEFAULT_ROUTE = BUSINESS_TYPE_ROUTES[BUSINESS_TYPE.REPLACEMENT];
/**
 * 業務種別からルートを取得する
 * @param businessType 業務種別
 * @returns ルートパス
 */
export function getRouteByBusinessType(businessType) {
    return BUSINESS_TYPE_ROUTES[businessType] || DEFAULT_ROUTE;
}
/**
 * 業務種別と案件IDから完全なルートパスを生成する
 * @param businessType 業務種別
 * @param projectId 案件ID
 * @returns 完全なルートパス
 */
export function generateProjectRoute(businessType, projectId) {
    const basePath = getRouteByBusinessType(businessType);
    return `${basePath}/${projectId}`;
}
